module.exports = __webpack_public_path__ + "img/p2-73.680a4530.png";